import create from 'zustand';
import { DitaQueryState } from './interfaces/CreateQueryState';
import { createCommonDitaQuerySlice } from './slices/DitaQuerySlices/CommonDitaQuerySlice';

export const useDitaQueryStore = create<DitaQueryState>((set) => ({
  ...createCommonDitaQuerySlice(set)
}));
